import { ITheme } from "../../utils/theme";

export const SelectContainerStyle = {
  justifyContent: "center"
}

export const SelectStyle = {
  margin: { xs: 0.5, lg: 1 },
  "&.MuiOutlinedInput-root": {
    "& .MuiSelect-select": {
      whiteSpace: { xs: "pre-wrap", sm: "nowrap" },
      padding: { xs: "5px 10px", lg: "16.5px 14px" },
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: { xs: '.85rem', lg: '16px' }
    }
  }
}

export const PlaceholderStyle = {
  color: (theme: ITheme) => theme.palette.grey[400]
}

export const AdditionalInfoStyle = {
  padding: { xs: "8px 2px", sm: 1 }
}

export const ScoreBoardGridStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row",
  background: (theme: ITheme) => theme.palette.blue[650],
  border: (theme: ITheme) => `solid 1px ${theme.palette.common.black}`,
  color: (theme: ITheme) => theme.palette.common.white,
  marginTop: 1
}

export const ScoreBoardContainerStyle = {
  width: "350px",
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  flexDirection: "row",
  marginLeft: "2px",
}

export const ScoreBoardIconStyle = {
  backgroundColor: (theme: ITheme) => theme.palette.red[200],
  borderColor: (theme: ITheme) => theme.palette.common.black,
  width: "20px",
  height: "20px",
  padding: "3px",
  border: 2,
  marginRight: 1,
}

export const ReportStyle = {
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  flexDirection: "row",
  marginTop: 1,
}

export const DisclaimerStyle = {
  display: "flex",
  color: (theme: ITheme) => theme.palette.red[650],
  cursor: "pointer",
  "& p": {
    fontWeight: "bold",
  }
}

export const DisclaimerContainerStyle = {
  position: "relative",
  width: "100%",
  margin: "auto"
}

export const DisclaimerContentStyle = {
  position: "absolute",
  zIndex: "999",
  top: "80px",
  width: "100%"
}

export const SelectMenuStyle = {
  maxHeight: { xs: 300, sm: 400, md: 500 }
}
